import { PlusOutlined } from '@ant-design/icons'
import { Button, message, Modal, Spin } from 'hljd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactCrop, { makeAspectCrop } from 'react-image-crop-6'
import 'react-image-crop-6/dist/ReactCrop.css'
import { getSuffix } from '../util'
import upload from '../util/upload'

class ImageUploader extends Component {
  constructor(props) {
    super(props)
    this.uploaderTrigger = React.createRef()
    this.state = {
      url: undefined,
      cropUrl: undefined,
      maskVisible: false,
      modalVisible: false,
      spinning: false,
      src: undefined,
      uploader: undefined,
      crop: {
        x: 0,
        y: 0,
        width: 0
      },
      cropRes: {
        x: undefined,
        y: undefined,
        width: undefined,
        height: undefined
      }
    }
  }
  componentDidMount() {
    const { inlineStyle } = this.props
    if (inlineStyle) {
      this.uploaderTrigger.current.style.height = `${inlineStyle.height}px`
    }
    const {
      upload_url,
      image_uptoken_url,
      domain_url,
      ...rest
    } = this.props.uploadOptions
    upload({
      browseButton: this.uploaderTrigger.current,
      events: {
        filesAdded: this.filesAdded,
        fileUploaded: this.fileUploaded,
        onError: this.onError
      },
      param: {
        type: 'image',
        upload_url,
        uptoken_url: image_uptoken_url,
        domain_url,
        max: this.props.max,
        ...rest
      }
    })
    this.setState({
      isCrop: this.props.isCrop,
      url: this.props.link,
      crop: Object.assign(this.state.crop, {
        aspect: this.props.aspect
      })
    })
  }
  filesAdded = (up, file) => {
    this.setState({
      spinning: true,
      cropUrl: undefined
    })
  }
  onError = (up, err, errTip) => {
    if (err.code === -600) {
      message.warning('上传的图片不可超过' + this.props.max || '100mb')
    }

    this.props.onError && this.props.onError(up, err, errTip)
  }
  fileUploaded = async (up, file, res) => {
    const domain = up.getOption('domain')

    const link = domain + (res.image_path ?? res.key)

    const info = JSON.stringify(res)
    if (!this.state.isCrop) {
      this.setState({
        url: link
      })
      this.props.uploadComplete &&
        this.props.uploadComplete(up, link, file, info)
    } else {
      this.setState({
        modalVisible: true,
        cropUrl: `${link}?imageMogr2/format/jpg/quality/30`,
        orginImgInfo: {
          up,
          file,
          info
        }
      })
    }
    this.setState({
      spinning: false
    })
  }
  displayMask = () => {
    this.setState({
      maskVisible: true
    })
  }
  hideMask = () => {
    this.setState({
      maskVisible: false
    })
  }
  triggerUploader = () => {
    const target = this.uploaderTrigger.current
    const event = new MouseEvent('click', {
      view: window,
      cancelable: true,
      bubbles: true
    })
    target.dispatchEvent(event)
  }
  onImageLoaded = image => {
    const { offsetWidth, offsetHeight } = image
    const {
      crop: { aspect },
      orginImgInfo: { info }
    } = this.state
    const { height, width } = JSON.parse(info)

    this.setState({
      // 裁剪框初始居中
      crop: makeAspectCrop(
        {
          x:
            height / width > aspect
              ? 50 - ((offsetHeight * aspect) / offsetWidth / 2) * 100
              : 0,
          y:
            height / width < aspect
              ? 50 - (offsetWidth / aspect / offsetHeight / 2) * 100
              : 0,
          width: 100,
          aspect: aspect
        },
        image.width / image.height
      )
    })
  }
  onCropComplete = (originConfig, cropRes) => {
    const { x, y, height, width } = cropRes
    this.setState({
      cropRes: { x, y, width, height }
    })
  }
  onCropChange = crop => {
    this.setState({
      crop
    })
  }
  onCancel = () => {
    const { aspect } = this.state.crop
    this.setState({
      modalVisible: false,
      cropUrl: undefined,
      crop: {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        aspect: aspect
      },
      cropRes: {
        x: undefined,
        y: undefined,
        width: undefined,
        height: undefined
      }
    })
  }
  onOk = () => {
    const { up, file, info } = this.state.orginImgInfo
    const imgInfo = JSON.parse(info)
    let {
      x = 0,
      y = 0,
      height = (imgInfo.height * this.state.crop.height) / 100,
      width = (imgInfo.width * this.state.crop.width) / 100
    } = this.state.cropRes
    const { aspect } = this.state.crop
    const emptyCrop = {
      x: 0,
      y: 0,
      width: this.state.crop.width,
      height: this.state.crop.height,
      aspect: aspect
    }
    const emptyCropRes = {
      x: undefined,
      y: undefined,
      width: (imgInfo.width * this.state.crop.width) / 100,
      height: (imgInfo.height * this.state.crop.height) / 100
    }
    this.setState(
      {
        url: `${this.state.cropUrl.split('?')[0]}?imageMogr2/crop/!${parseInt(
          width
        )}x${parseInt(height)}a${x}a${y}`,
        modalVisible: false,
        crop: emptyCrop,
        cropRes: emptyCropRes,
        cropUrl: undefined
      },
      () => {
        this.props.uploadComplete &&
          this.props.uploadComplete(up, this.state.url, file, info, {
            x: x,
            y: y,
            width: width,
            height: height
          })
      }
    )
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      url: nextProps.link,
      crop: Object.assign(this.state.crop, {
        aspect: nextProps.aspect
      })
    })
  }
  render() {
    const {
      inlineStyle,
      displaySize: { width, height },
      text
    } = this.props
    const suffix = getSuffix(this.state.url)
    return (
      <Spin spinning={this.state.spinning}>
        <div
          className="hlj-uploader-wrapper"
          style={inlineStyle}
          onMouseOver={this.displayMask}
        >
          <div className="hlj-uploader-trigger" ref={this.uploaderTrigger}>
            <div className="hlj-uploader-tip">
              <PlusOutlined
                className="hlj-uploader-plus"
                style={{
                  display: `${this.state.url ? 'none' : 'inline-block'}`
                }}
              />
              {text && <div> {text} </div>}
            </div>

            {this.state.url && (
              <img
                className="hlj-uploader-img__preview"
                src={`${
                  this.state.url
                }${suffix}imageView2/1/w/${width}/h/${height}`}
              />
            )}
          </div>

          {this.state.url && (
            <div
              className="hlj-uploader-mask"
              style={{
                width: `${inlineStyle ? inlineStyle.width : '100%'}`,
                height: `${inlineStyle ? inlineStyle.height + 'px' : '146px'}`,
                opacity: `${this.state.maskVisible ? '1' : '0'}`
              }}
              onMouseLeave={this.hideMask}
            >
              <div className="hlj-uploader-mask-icon">
                <Button
                  style={{
                    background: 'transparent',
                    borderColor: '#fff',
                    color: '#fff'
                  }}
                  onClick={this.triggerUploader}
                >
                  替换
                </Button>
              </div>
            </div>
          )}
          <Modal
            title="图片裁剪"
            visible={this.state.modalVisible}
            onCancel={this.onCancel}
            destroyOnClose={true}
            maskClosable={false}
            onOk={this.onOk}
          >
            {this.state.cropUrl && (
              <ReactCrop
                keepSelection
                src={this.state.cropUrl}
                crop={this.state.crop}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
                onImageLoaded={this.onImageLoaded}
              />
            )}
          </Modal>
        </div>
      </Spin>
    )
  }
}

ImageUploader.defaultProps = {
  uploadOptions: {}
}

ImageUploader.propTypes = {
  uploadOptions: PropTypes.shape({
    // 上传资源的地址：
    upload_url: PropTypes.string,
    // 上传图片前，从服务器获取的token地址
    image_uptoken_url: PropTypes.string,
    // 上传视频的仓库地址
    domain_url: PropTypes.string
  }),
  // 允许上传的最大视频，默认500M，eg: '500mb'
  max: PropTypes.string,
  // 框内的文字
  text: PropTypes.string,

  displaySize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }).isRequired
}

export default ImageUploader
